import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

// Countries the feed covers; mirrors backend/Hokue/listings/countries.py.
// URLs are /<code>/immobilier/... (ISO 3166-1 alpha-2, lowercase).
export const DEFAULT_COUNTRY = 'bj';
export const COUNTRIES = { bj: 'Bénin' };

export const feedPath = (country = DEFAULT_COUNTRY) => `/${country}/immobilier`;

// Renders the page for a known country code; anything else goes to the default country.
export function CountryGate({ children }) {
  const { country } = useParams();
  if (!COUNTRIES[country]) return <Navigate to={feedPath()} replace />;
  return children;
}
